<template>
    <div>
        <v-overlay :value="loading.data" opacity="0" z-index="4">
            <v-progress-circular
                indeterminate
                size="64"
                color="primary">
            </v-progress-circular>
        </v-overlay>
        <v-card
            flat
            v-if="!loading.data">
            <v-card-title>
                {{ $t('TRUCK_BRANDS_PAGE_TITLE') }}
                <v-spacer></v-spacer>
                <v-menu
                    :close-on-content-click="false"
                    offset-y>
                    <template v-slot:activator="{on}">
                        <v-btn
                            small
                            color="primary"
                            fab
                            v-on="on"
                            class="mx-1">
                            <v-icon>mdi-magnify</v-icon>
                        </v-btn>
                    </template>
                    <v-text-field
                        hide-details
                        append-icon="mdi-magnify"
                        solo
                        :label="$t('TRUCK_BRANDS_SEARCH')"
                        v-model="search"
                    ></v-text-field>
                </v-menu>
                <v-menu
                    offset-y>
                    <template v-slot:activator="{on}">
                        <v-btn
                            icon
                            v-on="on"
                            class="mx-1">
                            <v-icon>mdi-dots-vertical</v-icon>
                        </v-btn>
                    </template>
                    <v-list dense >
                        <v-list-item
                            link
                            v-if="authorizations.truck_brands.create"
                            @click="openTruckBrandDialog({editMode: false})"
                            >
                            <v-list-item-avatar>
                               <v-icon>mdi-plus-circle</v-icon>
                            </v-list-item-avatar>
                            <v-list-item-title>
                                {{ $t('new_truck_brands') }}
                            </v-list-item-title>
                        </v-list-item>
                        <v-list-item
                            v-if="authorizations.truck_brands.update && selected.truckBrands.length == 1"
                            link
                            @click="openTruckBrandDialog({editMode: true, id: selected.truckBrands[0].id})"
                            :disabled="!selected.truckBrands[0].meta.editable">
                            <v-list-item-avatar>
                                <v-icon :disabled="!selected.truckBrands[0].meta.editable">mdi-pencil</v-icon>
                            </v-list-item-avatar>
                            <v-list-item-content>
                                <v-list-item-title>{{ $t('ACTIONS_MENU_EDIT') }}</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-item
                            v-if="authorizations.truck_brands.delete && selected.truckBrands.length == 1"
                            link
                            @click="openTruckBrandDeleteDialog(selected.truckBrands[0].id)"
                            :disabled="!selected.truckBrands[0].meta.deletable">
                            <v-list-item-avatar>
                                <v-icon :disabled="!selected.truckBrands[0].meta.deletable">mdi-delete</v-icon>
                            </v-list-item-avatar>
                            <v-list-item-content>
                                <v-list-item-title>
                                    {{ $t('ACTIONS_MENU_DELETE') }}
                                </v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>
                </v-menu>
            </v-card-title>
            <v-card-subtitle>{{ $t('TRUCK_BRANDS_PAGE_SUBTITLE') }}</v-card-subtitle>
            <v-card-text>
                <v-data-table
                    dense
                    :items="truckBrands"
                    :headers="headers.truckBrands"
                    show-select
                    single-select
                    @click:row="openTruckModelDisplayDialog"
                    v-model="selected.truckBrands"
                    :search="search">
                     <!-- <template v-slot:item.view="{item}">
                        <v-btn
                            icon
                            @click="openTruckModelDisplayDialog(item)">
                            <v-icon>
                                mdi-eye
                            </v-icon>
                        </v-btn>
                    </template> -->
                </v-data-table>
            </v-card-text>
        </v-card>
        <TruckBrandDialog
            ref="truckBrandDialog"/>
        <DecisionDialog
            ref="decisionDialog"
            @submit="submitDecisionDialog"/>
        <AlertDialog
            ref="alertDialog"/>
        <TruckModelDisplayDialog
            ref="truckModelDisplayDialog"/>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import TruckBrandDialog from '../components/TruckBrandDialog';
import DecisionDialog from '../components/DecisionDialog';
import AlertDialog from '../components/AlertDialog';
import TruckModelDisplayDialog from '../components/TruckModelDisplayDialog'
export default {
    name: "TruckBrands",
    components: {
        TruckBrandDialog,
        DecisionDialog,
        AlertDialog,
        TruckModelDisplayDialog
    },
    data() {
        return {
            search: null,
            headers: {
                truckBrands: [
                     {text: null, value: "view"},
                    {text: this.$t('TRUCK_BRANDS_NAME'), value: "name"}
                ]
            },
            selected: {
                truckBrands: []
            },
            loading: {
                data: true
            }
        }
    },
    computed: {
        ...mapState("authentication", ["authorizations"]),
        ...mapState("truckBrand", ["truckBrands"])
    },
    methods: {
        ...mapActions("truckBrand", ["fetchTruckBrands", "removeTruckBrand"]),
        openTruckBrandDialog(params) {
            this.$refs.truckBrandDialog.open(params);
        },
        openTruckModelDisplayDialog(params){
            this.$refs.truckModelDisplayDialog.open(params);
        },
        openTruckBrandDeleteDialog(id) {
            this.$refs.decisionDialog.open({
                title: this.$t('DELETE_CONFIRM_TITLE'),
                content: this.$t('DELETE_CONFIRM_CONTENT'),
                action: "DELETE_TRUCK_BRAND",
                id: id
            });
        },
        submitDecisionDialog(params) {
            if(params.action == "DELETE_TRUCK_BRAND") {
                this.removeTruckBrand(params.id)
                    .then(async response => {
                        this.$refs.alertDialog.open(this.$t('SUCCESS_TITLE'), response.message);
                        this.loading.data = true;
                        await this.fetchTruckBrands();
                        this.loading.data = false;
                    })
                    .catch(error => {
                        this.$refs.alertDialog.open(this.$t('ERROR_TITLE'), error.message);
                    });
            }
        }
    },
    async created() {
        this.loading.data = true;
        await this.fetchTruckBrands();
        this.loading.data = false;
    }
}
</script>